<template>
	<div style="display: contents;">
		<template v-if="buttonComponent == 'v-btn'">
			<v-tooltip top>
				<template v-slot:activator="{ on: tooltip }">
					<v-btn
						v-on="{ ...tooltip }"
						:fab="button.params.fab ? button.params.fab : false"
						:icon="button.params.fab ? false : true"
						:small="button.params.small ? true : false"
						:fixed="button.params.fixed ? true : false"
						:bottom="button.params.bottom ? true : false"
						:right="button.params.right ? true : false"
						:dark="button.params.dark ? true : false"
						:color="button.params.button_color ? button.params.button_color : ''"
						@click="openDialog">
						<v-icon :color="button.params.color ? button.params.color : ''">{{ button.params.icon ? button.params.icon : 'mdi-draw-pen' }}</v-icon>
					</v-btn>
				</template>
        		<span>{{ button.params.tooltip ? button.params.tooltip : 'Firma' }}</span>
    		</v-tooltip>
		</template>

		<v-list-item v-else-if="buttonComponent == 'v-list-item'"
			dense 
			:disabled="disabled"
			@click.stop="openDialog()"
			ripple>
			<v-list-item-icon>
				<v-icon style="font-size: 18px">{{ button.params.icon ? button.params.icon : 'mdi-draw-pen' }}</v-icon>
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title>{{ button.params.tooltip ? button.params.tooltip : 'Firma' }}</v-list-item-title>
			</v-list-item-content>

		</v-list-item>

		<v-dialog
			v-model="dialog"
			:fullscreen="$vuetify.breakpoint.mdAndDown"
			width="800"
			:height="calcHeight"
			persistent
			ref="signatureDialog"
			eager>
			<v-card
				class="background-2"
				:class="{'': $vuetify.breakpoint.mdAndDown, 'round-card': $vuetify.breakpoint.lgAndUp}"
				:style="$vuetify.breakpoint.mdAndDown ? 'height: 100%; display: flex; flex-direction: column; padding-top: env(safe-area-inset-top);' : ''">
				<v-card-title class="pa-3 flex-shrink-0">
					<p class="pl-2 pl-xl-3">{{ button.params.tooltip ? button.params.tooltip : 'Firma' }}</p>
					<v-spacer></v-spacer>
					<v-btn icon @click.native.stop="dialog = !dialog"><v-icon>close</v-icon></v-btn>
				</v-card-title>
				<v-divider class="flex-shrink-0"></v-divider>

				<VueSignaturePad
					:style="$vuetify.breakpoint.mdAndDown ? 'flex: 1; min-height: 0;' : ''"
					:height="$vuetify.breakpoint.mdAndDown ? '100%' : startHeight + 'px'"
					ref="signaturePad"
					saveType="image/png"/>

				<v-divider class="flex-shrink-0"></v-divider>

				<v-card-actions class="flex-shrink-0" style="padding-bottom: calc(16px + env(safe-area-inset-bottom));">
					<v-btn @click="deleteAndCloseSignature" color="primary" text>Annulla</v-btn>
					<v-btn @click="deleteSignature" color="red" text>Cancella</v-btn>
					<v-spacer></v-spacer>
					<v-btn @click="saveSignature" :loading="loading" color="info" text>Salva</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>

export default {
	name: 'signature-dialog',
	props: {
		button: Object,
		buttonComponent: {type: String, default : 'v-btn'},
		model: Object,
		params: Object,
		modelDef: String,
		url: String,
		disabled: Boolean,
		fullModel: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			dialog: false,
			loading: false,
		}
	},

	computed: {
		startHeight() {
			if(this.$vuetify.breakpoint.mdAndUp) {
				return 400 
			}
			return window.innerHeight - 110
		}
	},
    
	watch: {

		dialog: {
			handler(newVal, oldVal) {
				this.$nextTick(function () {
					this.$refs.signaturePad.resizeCanvas(this.$refs.signaturePad.$refs.signaturePadCanvas)
				})
			},
		}

	},

	created() {
		window.addEventListener('resize', this.resizeCanvas)
		window.addEventListener("orientationchange", this.handleOrientationChange)
		this.resizeCanvas()
	},

	beforeDestroy() {
		window.removeEventListener('resize', this.resizeCanvas)
		window.removeEventListener('orientationchange', this.handleOrientationChange)
	},

	methods: {

		saveSignature() {
			this.loading = true
			this.model.signature = this.$refs.signaturePad.saveSignature().data ? this.$refs.signaturePad.saveSignature().data : null

			let modelDef = (this.params && this.params.modelDef) ? this.params.modelDef : this.modelDef

			if(modelDef == 'profile') {
				var url = 'profile-sign/'
			} else {
				var url = this.url ? this.url : modelDef + '-sign/' + this.model.id
			}
			var data = {}

			if(this.fullModel) {
				data = this.model
			} else {
				data = {signature: this.model.signature}
			}

			this.axios.put(url, data).then(response => {
				// get body data
				this.dialog = false
				this.loading = false
				this.$store.commit('setSnackbar', {timeout: 6000, text: 'Firma Salvata', value: true, color: 'success'})
				this.$eventBusUtility.$emit('savedSignatureTrouble')
				this.$eventBusUtility.$emit('refreshFileUploader')
			}, response => {
				if(modelDef === 'troubles') {
					var db = this.$store.getters.getDB

					this.model.offline = moment().format('X')
					this.model.edit = true

					db.troubles.put(this.model).then(result => {
						this.$store.commit('setSnackbar', {timeout: 6000, text: 'Firma Salvata', value: true, color: 'success'})
						this.show = false
						this.$eventBusUtility.$emit('savedSignatureTrouble')
						this.$eventBusUtility.$emit('refreshFileUploader')
						this.dialog = false
						this.loading = false						
					}).catch(result => {
						this.$store.commit('setSnackbar', {timeout: 6000, text: 'Errore salvataggio firma', value: true, color: 'error'})
						this.dialog = false
						this.loading = false						
					})
				} else {
					this.loading = false
				}
			})
		},

		openDialog() {
			this.$eventBusUtility.$emit('validateTroubleShow')
			if(!this.fullModel) {
			this.dialog = true
				setTimeout(() => {
					if(this.model.signature)
						this.$refs.signaturePad.fromDataURL(this.model.signature)
				}, 500)
			}

			if(this.dialog) {
				this.$eventBusUtility.$emit('showButtonsList', false)
			}

		},

		handleOrientationChange() {
			// Aspetta che il browser completi il reflow dopo il cambio di orientamento
			setTimeout(() => {
				this.resizeCanvas()
			}, 300)
		},

		resizeCanvas() {
			this.calcHeight()
			this.$nextTick(() => {
				if(typeof this.$refs.signaturePad !== 'undefined') {

					let ratio =  Math.max(window.devicePixelRatio || 1, 1)

					let image = this.$refs.signaturePad.saveSignature().data
					if(typeof image !== 'undefined') {
						this.$refs.signaturePad.$refs.signaturePadCanvas.width = this.$refs.signaturePad.$refs.signaturePadCanvas.offsetWidth * ratio
						this.$refs.signaturePad.$refs.signaturePadCanvas.height = this.$refs.signaturePad.$refs.signaturePadCanvas.offsetHeight * ratio

						this.$refs.signaturePad.$refs.signaturePadCanvas.getContext('2d').scale(ratio, ratio)
						this.$refs.signaturePad.signaturePad.clear()
						setTimeout(() => {
							this.$refs.signaturePad.fromDataURL(image)
						}, 800)
					}
				}
			})
		},

		calcHeight() {
			let h
			if(this.$vuetify.breakpoint.smAndUp) {
				h =  null
			} else {
				h =  window.innerHeight
			}
			return h
		},

		undo() {
			this.$refs.signaturePad.undoSignature()
		},
            
		deleteSignature() {
			this.$refs.signaturePad.clearSignature()
		},

		deleteAndCloseSignature() {
			this.$refs.signaturePad.clearSignature()
			this.dialog = !this.dialog
		}
	},

	mounted() {
		this.$eventBusUtility.$on('validTroubleShow', () => {
			this.dialog = true
			setTimeout(() => {
				if(this.model.signature)
					this.$refs.signaturePad.fromDataURL(this.model.signature)
			}, 500)
		})
	},
}
</script>

<style>

</style>
